import React, { useEffect } from 'react';
import { Phone } from 'lucide-react';
import { businessInfo } from '../mockData';

export const PhoneClickPage = () => {
  useEffect(() => {
    // Track Google Ads conversion for phone click
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-18154532014/phone_click',
        event_category: 'contact',
        event_label: 'phone_click',
        value: 1
      });
    }
    
    // Auto-redirect to phone dialer after a brief moment
    const timer = setTimeout(() => {
      window.location.href = `tel:${businessInfo.phone}`;
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center p-8">
        <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
          <Phone className="w-10 h-10 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-4">Connecting Your Call...</h1>
        <p className="text-gray-400 mb-6">You're being connected to Dezire Metal Roofing</p>
        <a 
          href={`tel:${businessInfo.phone}`}
          className="inline-flex items-center space-x-2 bg-primary hover:bg-accent text-white px-8 py-4 rounded-lg text-xl font-semibold transition-all"
        >
          <Phone className="w-6 h-6" />
          <span>{businessInfo.phone}</span>
        </a>
        <p className="text-gray-500 mt-4 text-sm">If the call doesn't start automatically, tap the button above</p>
      </div>
    </div>
  );
};
